
import router from '@/router'
import OpenLocalConfigDialog from './MenuBar/OpenLocalConfigDialog.vue'
import OpenRemoteConfigDialog from './MenuBar/OpenRemoteConfigDialog.vue'
import SaveLocalConfigDialog from './MenuBar/SaveLocalConfigDialog.vue'

// eslint-disable-next-line no-unused-vars
import { Component, Vue } from 'vue-property-decorator'
import { mapGetters } from 'vuex'

@Component({
  components: {
    OpenLocalConfigDialog,
    OpenRemoteConfigDialog,
    SaveLocalConfigDialog,
  },
  computed: {
    ...mapGetters({
      getDarkMode: 'getDarkMode',
    }),
  },
})
export default class MenuBar extends Vue {
  private confDBGUIItems: Object = [{ title: 'About' }, { title: 'Quit' }]
  private configurationsOpenItems: Object = [
    //{ title: 'New' },
    { title: 'Open local' },
    { title: 'Open remote' },
    //{ title: 'Close' },
    /*     { title: 'Save Local' },
    { title: 'Save Remote' }, */
  ]
  private configurationsSaveItems: Object = [
    { title: 'Save Local' },
    //{ title: 'Save Remote' },
    //{ title: 'Save as' },
  ]

  private openLocalConfigDialog: boolean = false
  private openRemoteConfigDialog: boolean = false
  private saveLocalConfigDialog: boolean = false
  //private aboutDialog: boolean = false

  data() {
    return {
      aboutDialog: false 
    }
  }

  public clickConfigurationOpenAction(e: Event, itemTitle: string) {
    e.preventDefault() //prevent context menu from closing if action is clicked
    e.stopPropagation()
    console.log("Open ",itemTitle)
    if (itemTitle == 'Open local') {
      //
      this.openLocalConfigDialog = true
      //this.actionListCallBack = this.insertStoreNodeReference
    } else if (itemTitle == 'Open remote') {
      this.openRemoteConfigDialog = true
    } else if (itemTitle == 'Save Local') {
      this.saveLocalConfigDialog = true
    }
  }

  public clickConfDBGUIItemAction(e: Event, itemTitle: string) {
    e.preventDefault() //prevent context menu from closing if action is clicked
    e.stopPropagation()
    console.log("DBGUI",itemTitle)
    if (itemTitle == 'About') {
      console.log("about")
      this.openLocalConfigDialog = true
      //this.actionListCallBack = this.insertStoreNodeReference
    } else if (itemTitle == 'Open remote') {
      this.openRemoteConfigDialog = true
    } else if (itemTitle == 'Save Local') {
      this.saveLocalConfigDialog = true
    }else{
      console.log(itemTitle)
    }
  }

  public doDiff() {
    console.log("here",this.$store.state.configMetaData)
    if (this.$store.state.configMetaData.configName == '') {
      router.push({path: 'diff'})
    }else{
      router.push({ path: 'diff',query: {to_cfg: `${this.$store.state.configMetaData.database}:${this.$store.state.configMetaData.name}` }})
    }
  }

}
